import styled from "styled-components";
import { Link } from "react-router-dom";

export const Container = styled.div`
  min-height: 692px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 0;
  overflow: hidden;
  
  background: linear-gradient(
    108deg,
    rgba(1, 147, 86, 1) 0%,
    rgba(10, 201, 122, 1) 100%
  );
`;

export const FormWrap = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  @media screen and (max-width: 400px) {
    height: 80%;
  }
`;

export const Icon = styled(Link)`
  margin-left: 32px;
  margin-top: 82px;
  text-decoration: none;
  color: #fff;
  font-weight: 700;
  font-size: 32px;

  @media screen and (max-width: 480px) {
    margin-left: 16px;
    margin-top: 8px;
  }
`;

export const FormContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (max-width: 480px) {
    padding: 10px;
  }
`;

export const Form = styled.form`
  background: transparent;
  max-width: 340px;
  width: 100%;
  z-index: 1;
  display: grid;
  gap: 0px;
  margin: 1px 65px;
  margin-bottom: 10px;
  padding: 18px 32px;
  border-radius: 14px;

  border: 1px solid rgba(255, 255, 255, 0.14);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  @media screen and (max-width: 480px) {
    margin: 1px 16px;
    padding: 16px 18px;
  }
`;

export const FormH1 = styled.h1`
  margin-bottom: 40px;
  color: #fff;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
`;

export const FormLabel = styled.label`
  margin-bottom: 8px;
  font-size: 14px;
  color: #fff;
`;

export const FormInput = styled.input`
  padding: 14px 14px;
  margin-bottom: 14px;
  border-radius: 10px;

  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(15, 23, 42, 0.45);
  color: #fff;

  &::placeholder {
    color: rgba(255, 255, 255, 0.65);
  }

  &:focus {
    outline: none;
    border-color: rgba(255, 255, 255, 0.32);
    box-shadow: 0 0 0 3px rgba(255, 255, 255, 0.10);
  }
`;

export const FormButton = styled.button`
  background: linear-gradient(135deg, rgba(255,255,255,0.95), rgba(255,255,255,0.75));
  padding: 14px 0;
  border: none;
  border-radius: 12px;

  color: #0F172A;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;

  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.35);
  transition: transform 0.12s ease, opacity 0.2s ease;

  &:hover {
    opacity: 0.95;
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const Text = styled.span`
  text-align: center;
  margin-top: 24px;
  color: #fff;
  font-size: 14px;
`;

// Nouveau style pour le bouton Toggle
export const ToggleButton = styled.button`
  background: transparent;
  border: none;
  color: white; /* Vert pour le lien */
  font-size: 22px;
  margin-top: 20px;
  cursor: pointer;
  text-decoration: underline;
  transition: color 0.2s ease-in-out;

  &:hover {
    color: #fff; /* Passe au blanc au survol */
  }
`;

export const GoogleButton = styled.button`
  background-color: #4285F4;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border-radius: 5px;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease-in-out;

  &:hover {
    background-color: #357ae8;
  }
`;

export const GenderSelect = styled.select`
  padding: 10px;
  margin: 8px 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  font-size: 16px;
`;

// ✅ Segmented toggle (Client / Chauffeur)
export const RoleToggleWrap = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 10px 0 18px 0;
  padding: 6px;
  border-radius: 999px;

  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.18);

  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.06);
`;

export const RoleToggleBtn = styled.button`
  flex: 1;
  border: none;
  cursor: pointer;
  padding: 12px 10px;
  border-radius: 999px;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 0.2px;

  transition: transform 0.12s ease, background 0.2s ease, color 0.2s ease,
    box-shadow 0.2s ease, opacity 0.2s ease;

  color: ${({ $active }) => ($active ? "#0F172A" : "rgba(255,255,255,0.85)")};
  background: ${({ $active }) =>
    $active ? "rgba(255,255,255,0.92)" : "transparent"};

  box-shadow: ${({ $active }) =>
    $active ? "0 10px 25px rgba(0,0,0,0.35)" : "none"};

  opacity: ${({ $active }) => ($active ? 1 : 0.85)};

  &:hover {
    opacity: 1;
  }

  &:active {
    transform: scale(0.98);
  }

  &:focus {
    outline: none;
  }
`;

export const StatsWrap = styled.div`
  display: flex;
  gap: 14px;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 12px;
`;

export const StatCard = styled.div`
  min-width: 220px;
  padding: 12px 14px;
  border-radius: 16px;

  background: rgba(255, 255, 255, 0.10);
  border: 1px solid rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);

  box-shadow: 0 18px 45px rgba(0,0,0,0.38);
`;

export const StatLabel = styled.div`
  color: rgba(255,255,255,0.85);
  font-weight: 900;
  font-size: 12px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const StatDot = styled.span`
  width: 10px;
  height: 10px;
  border-radius: 999px;
  background: ${({ $tone }) =>
    $tone === "clients" ? "rgba(34,197,94,0.95)" : "rgba(59,130,246,0.95)"};
  box-shadow: ${({ $tone }) =>
    $tone === "clients"
      ? "0 0 0 4px rgba(34,197,94,0.18)"
      : "0 0 0 4px rgba(59,130,246,0.18)"};
`;

export const DigitalCount = styled.div`
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono",
    "Courier New", monospace;
  font-weight: 900;
  font-size: 36px;
  letter-spacing: 2.5px;
  line-height: 1;

  padding: 10px 12px;
  border-radius: 12px;

  color: rgba(255, 255, 255, 0.98);
  background: rgba(0,0,0,0.55);
  border: 1px solid rgba(255,255,255,0.14);

  text-shadow:
    0 0 6px rgba(255,255,255,0.28),
    0 0 20px rgba(255,255,255,0.18);

  box-shadow:
    inset 0 0 0 1px rgba(255,255,255,0.06),
    0 16px 30px rgba(0,0,0,0.35);
`;

export const StatSub = styled.div`
  margin-top: 8px;
  color: rgba(255,255,255,0.65);
  font-size: 12px;
`;
